'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  width: 100%;\n  height: 100%;\n  padding: 10px;\n'], ['\n  width: 100%;\n  height: 100%;\n  padding: 10px;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  width: 100%;\n  height: 100%;\n  border-style: dashed;\n  border-width: 2px;\n  border-color: ', ';\n  border-radius: 5px;\n  overflow: auto;\n  -webkit-overflow-scrolling: touch;\n  padding: 10px;\n'], ['\n  width: 100%;\n  height: 100%;\n  border-style: dashed;\n  border-width: 2px;\n  border-color: ', ';\n  border-radius: 5px;\n  overflow: auto;\n  -webkit-overflow-scrolling: touch;\n  padding: 10px;\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  width: 100%;\n  height: 20px;\n'], ['\n  width: 100%;\n  height: 20px;\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n  width: 100%;\n  padding: 10px;\n'], ['\n  width: 100%;\n  padding: 10px;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _colors = require('../../../libs/colors');

var _Button = require('../../Button/Button');

var _Button2 = _interopRequireDefault(_Button);

var _P = require('../../P/P');

var _P2 = _interopRequireDefault(_P);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
} // Colors
// Components


var Container = _styledComponents2.default.div(_templateObject);

var Content = _styledComponents2.default.div(_templateObject2, _colors.grey);

var ButtonSeperator = _styledComponents2.default.div(_templateObject3);

var CardContent = _styledComponents2.default.div(_templateObject4);

var Attributes = function Attributes(_ref) {
  var children = _ref.children,
      onUpload = _ref.onUpload,
      onBack = _ref.onBack;
  return _react2.default.createElement(Container, null, _react2.default.createElement(Content, null, !!children && _react2.default.createElement(CardContent, null, children), _react2.default.createElement(CardContent, null, _react2.default.createElement(_P2.default, {
    align: 'center'
  }, _react2.default.createElement(_Button2.default, {
    onClick: onUpload,
    icon: 'addfile'
  }, 'Upload')), _react2.default.createElement(ButtonSeperator, null), _react2.default.createElement(_P2.default, {
    align: 'center'
  }, _react2.default.createElement(_Button2.default, {
    onClick: onBack,
    size: 'small',
    theme: 'grey'
  }, 'Back')))));
};

Attributes.propTypes = {
  children: _propTypes2.default.node,
  onUpload: _propTypes2.default.func,
  onBack: _propTypes2.default.func
};
exports.default = Attributes;